export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-950"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20abstract%20composition%20with%20film%20reel%20elements%2C%20golden%20light%20rays%20streaming%20through%20dark%20theater%20space%2C%20elegant%20modern%20movie%20poster%20collage%20effect%2C%20soft%20bokeh%20background%2C%20rich%20warm%20amber%20and%20deep%20burgundy%20tones%2C%20luxurious%20cinema%20atmosphere%2C%20high%20end%20editorial%20design%20style%2C%20no%20text%20overlay&width=1600&height=900&seq=hero-bg-777cinema&orientation=landscape"
          alt="777影院影视主题背景"
          className="w-full h-full object-cover object-center"
        />
      </div>

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/85 via-foreground-950/70 to-foreground-950/90"></div>

      {/* Content */}
      <div className="relative w-full px-4 md:px-6 py-20 md:py-28">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left: Text */}
          <div className="flex-1 w-full text-center lg:text-left">
            {/* Tags */}
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-2 mb-5">
              <span className="px-3 py-1 text-xs font-medium bg-primary-500/20 text-primary-300 rounded-full border border-primary-500/30 whitespace-nowrap">
                官方入口
              </span>
              <span className="px-3 py-1 text-xs font-medium bg-accent-500/20 text-accent-300 rounded-full border border-accent-500/30 whitespace-nowrap">
                安全稳定
              </span>
              <span className="px-3 py-1 text-xs font-medium bg-background-50/15 text-background-100/80 rounded-full border border-background-50/20 whitespace-nowrap">
                每日更新
              </span>
            </div>

            {/* H1 */}
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-background-50 leading-tight mb-3">
              777影院 - 您的高清影视观看首选入口
            </h1>

            {/* Slogan */}
            <p className="text-base md:text-lg text-accent-300 font-medium mb-5">
              7777影院 · 777777影院 · 77777影院 统一官方导航
            </p>

            {/* Description */}
            <p className="text-sm md:text-base text-background-200/80 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              777影院作为数字变体影院的官方聚合入口，致力于为全国影迷提供安全、稳定、高速的观影导航服务。无论您通过7777影院、777777影院还是77777影院搜索而来，这里都是您进入高清影视世界的统一门户。本站每日同步更新最新电影、热门电视剧、综艺动漫等海量资源，让您畅享极致的在线观影体验。
            </p>

            {/* Stats */}
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">20000+</div>
                <div className="text-xs text-background-300/70 mt-1">影视资源</div>
              </div>
              <div className="w-px h-10 bg-background-50/15 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">每日更新</div>
                <div className="text-xs text-background-300/70 mt-1">片源同步</div>
              </div>
              <div className="w-px h-10 bg-background-50/15 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">全端适配</div>
                <div className="text-xs text-background-300/70 mt-1">随时观影</div>
              </div>
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#carousel"
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-all duration-200 text-sm whitespace-nowrap cursor-pointer text-center"
              >
                立即浏览推荐
              </a>
              <a
                href="#index"
                className="w-full sm:w-auto px-8 py-3 bg-background-50/10 hover:bg-background-50/20 text-background-50 border border-background-50/25 font-medium rounded-lg transition-all duration-200 text-sm whitespace-nowrap cursor-pointer text-center"
              >
                查看全部专题
              </a>
            </div>
          </div>

          {/* Right: Visual */}
          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-foreground-950/50">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20cinematic%20film%20poster%20composition%20with%20golden%20film%20strip%20curling%20through%20darkness%2C%20warm%20spotlight%20effect%2C%20abstract%20movie%20elements%20floating%20in%20space%2C%20luxurious%20dark%20theater%20ambiance%2C%20rich%20amber%20and%20burgundy%20color%20palette%2C%20high%20contrast%20dramatic%20lighting%2C%20elegant%20modern%20design%2C%20no%20text%2C%20artistic%20cinema%20aesthetic&width=800&height=1000&seq=hero-visual-777cinema&orientation=portrait"
                alt="777影院影视主题主视觉"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/40 via-transparent to-transparent"></div>
            </div>
            {/* Floating accent */}
            <div className="hidden lg:block absolute -bottom-4 -left-4 w-24 h-24 bg-primary-500/20 rounded-full blur-2xl"></div>
            <div className="hidden lg:block absolute -top-6 -right-6 w-32 h-32 bg-accent-500/10 rounded-full blur-3xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
}